import { makeStyles } from '@mui/styles';
const COLOR_MANDATORY = '#F01C10';

export const useStyles = makeStyles((theme) => ({
  colorMandatory: {
    color: COLOR_MANDATORY,
  },
  inputCardNumber: {
    position: 'relative',
    '& span': {
      paddingLeft: theme.spacing(0.5),
      color: '#7C7C7C',
      fontSize: 12,
      position: 'absolute',
      top: -6,
      left: 12,
      zIndex: 1,
      backgroundColor: theme.palette.common.white,
    },
    '& span.highlight': {
      color: COLOR_MANDATORY,
      marginLeft: 76,
      paddingLeft: 0,
      paddingRight: 5,
    },
    '& span.highlightDate': {
      color: COLOR_MANDATORY,
      marginLeft: 86,
      paddingLeft: 1,
      paddingRight: 4,
    },
    '& span.highlightCVC': {
      color: COLOR_MANDATORY,
      marginLeft: 29,
      paddingLeft: 1,
      paddingRight: 5,
    },
  },
}));
